import { customElement } from "lit/decorators.js";
import { NotificationService } from "../../../../../libs/ui-components/notification";
import { LiveEventFormPage } from "../live-event-form-page/live-event-form-page";
import { navigateTo } from "../../router";
import { t, translate } from "../../translations/i18n";

@customElement("edit-live-event-page")
export class EditLiveEventPage extends LiveEventFormPage {
  protected override get mode() {
    return "edit" as const;
  }

  protected override get urlSegment() {
    return "edit";
  }

  protected override get desktopTitle() {
    return t("createLiveEventPage.editLiveEvent");
  }

  protected override get streamSettingsButtonLabel() {
    return t("createLiveEventPage.saveChanges");
  }

  protected override get isStreamSettingsTabEnabled() {
    return true;
  }

  protected override onSaveAndContinueSuccess(): void {
    // No URL update needed for edit mode
  }

  protected override async handleStreamSettingsAction(): Promise<void> {
    if (!this.formService.validateForm()) {
      NotificationService.error(translate("createLiveEventPage.fillRequiredFields"));
      return;
    }

    const success = await this.formService.saveEvent();
    if (success) {
      this.isSaved = true;
      this.formService.reset();
      this.liveEventsService.refetch();
      NotificationService.success(translate("createLiveEventPage.eventSaved"));
      navigateTo("live-events");
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "edit-live-event-page": EditLiveEventPage;
  }
}
